const tableBlock = {
  init(): void {
    document.querySelectorAll<HTMLElement>('.table-block').forEach((target: HTMLElement) => {
      this.handleTableBlock(target)
    })
  },

  handleTableBlock(target): void {
    const el = {
      firstColumn: target.querySelector('table tr:first-child td:first-child'),
      firstRow: target.querySelector('table tr:first-child'),
      table: target.querySelector('.table-block__table table'),
      tableBackground: target.querySelector('.table-block__table-background'),
      tableContainer: target.querySelector('.table-block__table'),
    }

    const method = {
      init(): void {
        method.adjustBackgroundPosition()
        window.addEventListener('resize', method.adjustBackgroundPosition)
      },

      adjustBackgroundPosition(): void {
        if (el.tableBackground) {
          el.tableBackground.style.left = `${el.firstColumn.offsetWidth}px`
          el.tableBackground.style.top = `${el.firstRow.offsetHeight}px`

          if (el.table.offsetWidth > el.tableContainer.offsetWidth) {
            el.tableBackground.style.right = `${el.tableContainer.offsetWidth - el.table.offsetWidth + 1}px`
          } else {
            el.tableBackground.style.right = '0px'
          }

          if (el.tableContainer.firstElementChild.tagName === 'P') {
            el.tableBackground.style.top = `${el.firstRow.offsetHeight + el.tableContainer.firstElementChild.offsetHeight}px`
          }
        }
      },
    }

    method.init()
  },
}

export default tableBlock
